<template>
  <div class="flex align-items-center post-info-stats">
    <div class="flex items-center post-info-comments">
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.59766 2.36655H14.9428V3.38078H4.59766V2.36655Z"
        />
        <path
          d="M4.59766 4.39499H11.224V5.40922H4.59766V4.39499Z"
        />
        <path
          d="M4.59766 6.42346H12.9143V7.43769H4.59766V6.42346Z"
        />
        <path
          d="M2.2313 0V3.38076H0V15.66L4.06577 12.4074H12.475V9.80421H13.2437L17.3095 13.0568V0H2.2313ZM11.4608 11.3932H3.70998L1.01423 13.5498V4.39499H2.2313V9.80421H11.4608V11.3932ZM16.2953 10.9466L13.5995 8.78998H3.24553V1.01423H16.2953V10.9466Z"
        />
      </svg>

      10
    </div>

    <div class="flex items-center post-info-likes">
      <svg
        width="17"
        height="15"
        viewBox="0 0 17 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.6239 8.05226C15.8783 7.76829 16.0333 7.39347 16.0333 6.98337C16.0333 6.09941 15.3139 5.38005 14.4299 5.38005H11.3181C11.6262 4.44477 11.7577 3.2038 11.7577 2.67185V2.13777C11.7577 0.959145 10.7986 0 9.61995 0H9.08551C8.84038 0 8.6266 0.166746 8.5671 0.404751L8.27601 1.56948C7.86805 3.20059 6.57292 5.00024 5.23254 5.32732C4.99774 4.73302 4.41805 4.31116 3.74109 4.31116H0.534442C0.23943 4.31116 0 4.55059 0 4.84561V14.4656C0 14.7606 0.23943 15 0.534442 15H3.74109C4.3785 15 4.93005 14.6262 5.18836 14.0861L7.0247 14.6982C7.62506 14.8985 8.25071 15 8.88385 15H13.361C14.245 15 14.9644 14.2806 14.9644 13.3967C14.9644 13.1882 14.9245 12.9887 14.8518 12.8059C15.5316 12.6203 16.0333 11.9972 16.0333 11.2589C16.0333 10.8488 15.8783 10.474 15.6239 10.19C15.8783 9.90606 16.0333 9.53124 16.0333 9.12114C16.0333 8.71105 15.8783 8.33622 15.6239 8.05226ZM4.27553 13.3967C4.27553 13.6913 4.03575 13.9311 3.74109 13.9311H1.06888V5.38005H3.74109C4.03575 5.38005 4.27553 5.61983 4.27553 5.91449V13.3967ZM13.361 8.5867H14.4299C14.7246 8.5867 14.9644 8.82648 14.9644 9.12114C14.9644 9.4158 14.7246 9.65558 14.4299 9.65558H13.361C13.066 9.65558 12.8266 9.89501 12.8266 10.19C12.8266 10.485 13.066 10.7245 13.361 10.7245H14.4299C14.7246 10.7245 14.9644 10.9643 14.9644 11.2589C14.9644 11.5536 14.7246 11.7933 14.4299 11.7933H13.361C13.066 11.7933 12.8266 12.0328 12.8266 12.3278C12.8266 12.6228 13.066 12.8622 13.361 12.8622C13.6557 12.8622 13.8955 13.102 13.8955 13.3967C13.8955 13.6913 13.6557 13.9311 13.361 13.9311H8.88385C8.36579 13.9311 7.8538 13.8481 7.36247 13.6842L5.34442 13.0115V6.39834C6.18278 6.23907 7.00332 5.7082 7.74406 4.83919C8.46734 3.9905 9.0538 2.86532 9.31283 1.82886L9.50273 1.06888H9.61995C10.2093 1.06888 10.6888 1.54846 10.6888 2.13777V2.67185C10.6888 3.38943 10.4644 4.7658 10.1772 5.38005H9.08551C8.7905 5.38005 8.55107 5.61948 8.55107 5.91449C8.55107 6.2095 8.7905 6.44893 9.08551 6.44893H14.4299C14.7246 6.44893 14.9644 6.68872 14.9644 6.98337C14.9644 7.27803 14.7246 7.51782 14.4299 7.51782H13.361C13.066 7.51782 12.8266 7.75725 12.8266 8.05226C12.8266 8.34727 13.066 8.5867 13.361 8.5867Z"
        />
      </svg>

      5
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElPostCommentsAndLikes'
}
</script>

<style lang="scss">
.post-info-stats {
  gap: 14px;
}

.post-info-comments,
.post-info-likes {
  font-size: 14px;
  gap: 12px;

  path {
    fill: #6E747A;
  }
}
</style>